import { Component, OnInit } from '@angular/core';
import {EmailTemplate} from "../../../../../dto/templates/email-template";
import {ConfigService} from "../../../../../services";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CustomerEmailTemplatesService} from "../../../../services/customer-email-templates.service";
import {CustomerConfig} from "../../../../../dto/customer-config";
import {PushNotificationTemplatesService} from "../../../../../services/crud/push-notification-templates.service";
import {PushNotificationTemplate} from "../../../../../dto/templates/html-template";
import {PushNotificationLoadsConfig} from "../../../../../dto/push-notification-loads-config";

@Component({
  selector: 'app-push-notification-load-configs',
  templateUrl: './push-notification-load-configs.component.html',
  styleUrls: ['./push-notification-load-configs.component.css']
})
export class PushNotificationLoadConfigsComponent implements OnInit {

  pushNotificationTemplates: PushNotificationTemplate[];

  constructor(
    private configService: ConfigService,
    private formBuilder: FormBuilder,
    private pushNotificationTemplatesService: PushNotificationTemplatesService,
  ) { }

  configForm: FormGroup;

  ngOnInit() {
    this.pushNotificationTemplatesService.getMany().subscribe(result => {
      this.pushNotificationTemplates = result.data;
      this.configService.getPushNotificationLoadsConfig().subscribe(data => {
        this.initForm(data);
      });
    });
  }

  initForm(value: PushNotificationLoadsConfig = null) {
    if (value != null) {
      this.configForm = this.formBuilder.group({
        firstBtlCompletedTemplateId:     value.firstBtlCompletedTemplateId,
        btlPendingLoadTemplateId:            value.btlPendingLoadTemplateId,
        btlSuccessLoadTemplateId:            value.btlSuccessLoadTemplateId,
        btlSuccessPartialLoadTemplateId: value.btlSuccessPartialLoadTemplateId,
        btlPendingBelowMinLoadTemplateId: value.btlPendingBelowMinLoadTemplateId,
        btlDeclinedLoadTemplateId: value.btlDeclinedLoadTemplateId,
        btlConfirmAddressTemplateId: value.btlConfirmAddressTemplateId,

      });
    }
    this.configForm.markAsPristine();
  }

  onSubmit(form: FormGroup) {
    this.configService.setPushNotificationLoadsConfig(form.value).subscribe(result => {
      this.initForm();
    });
  }
}
